<template>
    <b-input-group class="assign-select">
        <multiselect
                :options="assessmentTypes"
                label="assessmentType"
                track-by="assessmentTypeId"
                v-model="selected"
                selectLabel=""
                placeholder="Select an assessment type"
                tagPlaceholder=" "
                deselectLabel=""
                :disabled="disabled"
        >
            <template slot="caret">
                <caret-icon></caret-icon>
            </template>
        </multiselect>
        <b-input-group-append v-if="confirmButtons && allowed" class="transparent">
            <b-btn
                    v-if="disabled"
                    @click="disabled = false"
            >
                <font-awesome-icon
                        :icon="['far', 'pencil']"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!disabled && !loading"
                    @click="onConfirm"
            >
                <font-awesome-icon
                        :icon="['fal', 'check']"
                        class="green"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!disabled && !loading"
                    @click="onCancel"
            >
                <font-awesome-icon
                        :icon="['far', 'times']"
                        class="red"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="loading"
            >
                <font-awesome-icon
                        :icon="['fal', 'spinner']"
                        size="sm"
                        spin
                >
                </font-awesome-icon>
            </b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
  import { cloneDeep } from 'lodash';

  export default {
    name: 'Assessment-Type-Select',
    props: {
      options: {},
      value: {},
      confirmButtons: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        allowed: false,
        disabled: false,
        selected: null,
        originalSelected: null,
        assessmentTypes: [],
      };
    },

    watch: {
      value: {
        handler(newValue) {
          this.selected = newValue;
          this.originalSelected = cloneDeep(newValue);
        },
        immediate: true,
        deep: true,
      },
      options(newOptions) {
        this.assessmentTypes = newOptions;
      },
      confirmButtons: {
        handler(newConfirmButtons) {
          this.allowed = newConfirmButtons;
        },
        immediate: true,
      },
    },

    mounted() {
      this.assessmentTypes = this.options;
      if (this.confirmButtons) {
        this.disabled = true;
      }
    },

    methods: {
      onCancel() {
        this.selected = this.originalSelected;
        this.disable();
      },
      onConfirm() {
        this.$emit('input', this.selected);
        this.$emit('confirm', this.selected);
      },
      disable() {
        this.disabled = true;
      },
      onInput(value) {
        if (!this.confirmButtons && !this.disabled) {
          this.$emit('input', value);
        }
      }
    },
  };
</script>

<style lang="scss">
    .assign-select {
        .multiselect__option {
            padding-left: 25px;

            &--disabled {
                padding-left: 10px;
            }
        }
    }
</style>
